export default __webpack_public_path__ + "static/media/Cry for War.95aadb96.jpg";